import { Badge, Text } from "@mantine/core";

import classes from "./PlanCard.module.css";

export interface PlanBadgeProps {
    text: string;
    testId?: string;
    className?: string;
}

export const PlanBadge = ({ text, testId, className }: PlanBadgeProps) => (
    <Badge data-testid={testId} className={className ? className : classes.badge} autoContrast>
        <Text fw={700} fz={"xxs"}>
            {text}
        </Text>
    </Badge>
);
